<span
  nz-icon
  nz-tooltip
  [nzType]="icon()"
  [class]="classColor()"
  [nzTooltipTitle]="tooltip()"
></span>
